export default __webpack_public_path__ + "static/media/png.2e08ea34.svg";